import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
} from "react";

import { ISegment } from "./SegmentTypes";

const defaultSegmentContext: SegmentContextInterface = {
  isModalVisible: false,
  setIsModalVisible: () => true,
  toggleModalVisibility: () => {},
  //SegmentsArray:[],
  segmentList: [],
  setSegmentList: () => {},
  addSegment: () => {},
};

export const SegmentContext = createContext<SegmentContextInterface>(
  defaultSegmentContext
);

const SegmentProvider: React.FC<Props> = ({ children }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [segmentList, setSegmentList] = useState<ISegment[] >([]);

  //var SegmentsArray: ISegment[] = [];

  const toggleModalVisibility = () => {
    setIsModalVisible(!isModalVisible);
    //console.log("isModalVisible", isModalVisible);
  };

  const addSegment = (newSegment: ISegment ) => {
    console.log("value in addSegment", newSegment);
    if (newSegment) {
      setSegmentList((prevSegments) => [...prevSegments , newSegment]);
    }
    console.log("segment list", segmentList);
  };

  const providerValue = {
    isModalVisible,
    setIsModalVisible,
    toggleModalVisibility,
    //SegmentsArray,
    segmentList,
    setSegmentList,
    addSegment,
  };
  return (
    <SegmentContext.Provider value={providerValue}>
      {children}
    </SegmentContext.Provider>
  );
};

interface Props {
  children?: React.ReactNode;
}

interface SegmentContextInterface {
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  toggleModalVisibility: () => void;
  //SegmentsArray:ISegment[];
  segmentList: ISegment[];
  setSegmentList: Dispatch<SetStateAction<ISegment[] >>;
  addSegment: (newSegment: ISegment) => void;
}

export default SegmentProvider;
